import { DefaultService } from '@/services/DefaultService';

export default class AssClienteFormaPagamentoB2BEmpresaService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAll(column, order, page, limit, situacao, idEmpresa, ...params) {
        return this._http.get( encodeURI(`${this._env}/b2b/b2bempresa/cliente/assformapagto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idEmpresa=${idEmpresa}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
	}

    findAllCombo(idEmpresa = 0, ...params) {
		return this._http.get(encodeURI(`${this._env}/b2b/b2bempresa/cliente/formapagto/getcombo/b2bempresas.json?idempresa=${idEmpresa}&param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
            this.handleError(err);
		});
	}

    find(id) {
		return this._http.get(`${this._env}/b2b/b2bempresa/cliente/assformapagto/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
	}

    updateSituacao(assClienteFormaPagtoB2BEmpresa) {
        const { idb2b_assempresaclienteformapagto: idB2BEmpresaClienteFormaPagamento, ...rest } = assClienteFormaPagtoB2BEmpresa;

        return this._http.post(`${this._env}/b2b/b2bempresa/cliente/assformapagto/updatesituacao`, { idB2BEmpresaClienteFormaPagamento, ...rest }, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }

    save(assClienteFormaPagtoB2BEmpresa) {
        return this._http.post(`${this._env}/b2b/b2bempresa/cliente/assformapagto`, assClienteFormaPagtoB2BEmpresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }

    insertBulk(assClienteFormaPagtoB2BEmpresa) {
        return this._http.post(`${this._env}/b2b/b2bempresa/cliente/assformapagto/insert-bulk`, assClienteFormaPagtoB2BEmpresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }
}